import { render } from "./SiteManagement.vue?vue&type=template&id=ef000ade&scoped=true"
import script from "./SiteManagement.js?vue&type=script&lang=js"
export * from "./SiteManagement.js?vue&type=script&lang=js"

import "./SiteManagement.vue?vue&type=style&index=0&id=ef000ade&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef000ade"]])

export default __exports__